import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        this.modalInstance = M.Modal.init(this.element, {
            inDuration: 0,
            outDuration: 0,
            onCloseEnd: () => this.element.remove()
        })

        this.modalInstance.open()
    }
}
